import {
    Box,
    Button,
    Text,
    Tooltip,
    useBoolean,
    useOutsideClick
} from '@chakra-ui/react'
import { DocumentTypes } from 'pages/Report/types'
import { useRef } from 'react'

interface FileGeneratorProps {
    callAPI: (type: DocumentTypes) => void
    onPendingImages?: () => void
    onlyPDF?: boolean
    loading: boolean
}

export const FileGenerator = ({
    callAPI,
    onPendingImages,
    onlyPDF,
    loading
}: FileGeneratorProps) => {
    const refTooltip = useRef(null)
    const [tooltipState, setTooltipState] = useBoolean(false)
    useOutsideClick({
        ref: refTooltip,
        handler: setTooltipState.off
    })
    const files: DocumentTypes[] = ['CSV', 'EXCEL', 'PDF']
    const downloadCsv = (type: DocumentTypes) => {
        if (!onlyPDF) {
            setTooltipState.toggle()
        }
        callAPI(type)
    }

    const onGenerateFile = () => {
        if (onlyPDF) {
            downloadCsv('PDF')
            return
        }

        setTooltipState.toggle()
    }

    const downloadPendingImages = () => {
        setTooltipState.off()
        onPendingImages?.()
    }

    return (
        <>
            <Tooltip
                ref={refTooltip}
                isOpen={tooltipState}
                hasArrow
                placement="bottom-start"
                backgroundColor="none"
                label={
                    <Box
                        bg="white"
                        width="150px"
                        borderRadius="8px"
                        pointerEvents="auto"
                        textAlign="center"
                        paddingY="12px"
                    >
                        <Text
                            fontSize="14px"
                            fontWeight={'bold'}
                            padding="16px 10px"
                            color="black"
                        >
                            Selecionar tipo:
                        </Text>

                        {files.map((file, index) => {
                            return (
                                <Button
                                    key={index}
                                    width="100%"
                                    height="32px"
                                    colorScheme="off-white"
                                    color="black"
                                    onClick={() => downloadCsv(file)}
                                    _hover={{
                                        background: 'grayscale.50'
                                    }}
                                >
                                    {file}
                                </Button>
                            )
                        })}

                        {onPendingImages && (
                            <Button
                                width="100%"
                                height="32px"
                                colorScheme="off-white"
                                color="black"
                                onClick={downloadPendingImages}
                                _hover={{
                                    background: 'grayscale.50'
                                }}
                            >
                                Imagens Pendentes
                            </Button>
                        )}
                    </Box>
                }
            >
                <Button
                    colorScheme="primary"
                    onClick={onGenerateFile}
                    isLoading={loading}
                >
                    Gerar relatório
                </Button>
            </Tooltip>
        </>
    )
}
